import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translation_en from './en/en.json';
import translation_it from './it/it.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: translation_en,
    },
    it: {
      translation: translation_it,
    },
  },
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
